import { createSelector } from 'reselect';
import { selectUserPublishSettings } from './selectUserPublishSettings';
import { SettingType } from '../../../api/vault/publishEndpoints';

export const selectVaultPublishSettings = createSelector(
  selectUserPublishSettings,
  (userPublishSettings) => (userPublishSettings === null
    ? null
    : userPublishSettings.filter((s) => s.type === SettingType.LAN || s.type === SettingType.Yahoo)),
);
